import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { LegacyExportTask } from '../core/export-task-legacy';
import { ExportTask } from '../core/export-task';

@Component({
  selector: 'app-export-overlay-task',
  templateUrl: './export-task.component.html',
  styleUrl: './export-task.component.scss',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
  ]
})
export class ExportTaskComponent {
  @Input() task: LegacyExportTask | ExportTask;

  onCancelButtonPressed() {
    this.task.cancel();
  }
}
